import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_pa-3 _tac _flexcol _gap-2 _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushBlockedParagraph) + " ", 1 /* TEXT */),
    _createVNode(_component_base_button, {
      tag: "a",
      theme: "accent",
      target: "_blank",
      rel: "noopener noreferrer",
      size: "micro",
      class: "_ttl",
      href: $options.url,
      onClick: $options.onButtonClick,
      "data-qa": "notification-box-button:ReadInstructions"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushHowToUnblockLink), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href", "onClick"]),
    _createElementVNode("button", {
      class: "gfu-btn__text _tc--accent",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onMessageHide && $options.onMessageHide(...args)))
    }, _toDisplayString(_ctx.Resources.Layout.HideThisMessageButton), 1 /* TEXT */)
  ]))
}